import QuestionnaireType from 'common/questionnaires/QuestionnaireType';

export const QUESTIONNAIRE_CLEAR = 'QUESTIONNAIRE_CLEAR';

function clear(questionnaireType) {
  return {
    type: QUESTIONNAIRE_CLEAR,
    questionnaireType,
  };
}

export function clearPreQualQuestionnaire() {
  return (dispatch) => {
    dispatch(clear(QuestionnaireType.PreQualifying));
  };
}

export function clearFormQuestionnaire() {
  return (dispatch) => {
    dispatch(clear(QuestionnaireType.Form));
  };
}

export function clearQuestionnaire(questionnaireType) {
  return (dispatch) => {
    dispatch(clear(questionnaireType));
  };
}
